// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Invoice_DetailResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for invoice detail.
 *
 * Object dados: the invoice row itself (flat). getDados() returns the
 * Invoice_InvoiceRow so the dados wire shape is the flat invoice record
 * (the row's public properties serialize one-to-one). Populate via
 * Invoice_DetailResponse::fromInvoiceRow().
 */
import type { Invoice_InvoiceRow } from './Invoice_InvoiceRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Invoice_DetailResponseDados = Invoice_InvoiceRow;

export type Invoice_DetailResponse = ApiResponse<Invoice_DetailResponseDados>;

registerResponseContract('Invoice_DetailResponse', {
  id:                    { type: 'number',  required: false },
  franchise_id:          { type: 'number',  required: false },
  franchise_name:        { type: 'string',  required: false },
  external_id:           { type: 'string',  required: false },
  invoice_number:        { type: 'string',  required: false },
  invoice_type:          { type: 'string',  required: false },
  document_kind:         { type: 'string',  required: false },
  status:                { type: 'string',  required: false },
  customer_doc:          { type: 'string',  required: false },
  customer_doc_type:     { type: 'string',  required: false },
  customer_name:         { type: 'string',  required: false },
  customer_email:        { type: 'string',  required: false },
  customer_phone:        { type: 'string',  required: false },
  cliente_id:            { type: 'number',  required: false },
  total_amount:          { type: 'number',  required: false },
  tax_amount:            { type: 'number',  required: false },
  taxless_amount:        { type: 'number',  required: false },
  emission_date:         { type: 'string',  required: false },
  authority_date:        { type: 'string',  required: false },
  authority_number:      { type: 'string',  required: false },
  authority_message:     { type: 'string',  required: false },
  xml_url:               { type: 'string',  required: false },
  pdf_url:               { type: 'string',  required: false },
  provider_code:         { type: 'string',  required: false },
  provider_raw_response: { type: 'string',  required: false },
  related_entity_type:   { type: 'string',  required: false },
  related_entity_id:     { type: 'number',  required: false },
  emission_group_id:     { type: 'string',  required: false },
  created_by:            { type: 'string',  required: false },
  created_at:            { type: 'string',  required: false },
  updated_at:            { type: 'string',  required: false },
})
